"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const moment = require("moment");
const marked_ts_1 = require("marked-ts");
const hashCode = (s) => s.split("").reduce((a, b) => ((a << 5) - a + b.charCodeAt(0)) | 0, 0);
const getHash = (data) => hashCode(JSON.stringify({ title: data.title, poster: data.poster && data.poster.url, body: data.body })).toString();
const MODE_LANDSCAPE_IMAGE_TOP = "liggende_bilde_i_topp";
const MODE_PORTRAIT_IMAGE_LEFT = "staaende_bilde_venstre";
const MODE_BIG_IMAGE = "stort_bilde_med_lenke";
class ModalDialog extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showModal: this.props.display,
        };
        this.componentDidMount = () => {
            if (typeof window !== "undefined") {
                const existingHash = window.localStorage.getItem("cw-modal-dialog");
                if (!existingHash) {
                    window.localStorage.setItem("cw-modal-dialog", getHash(this.props));
                }
            }
        };
        this.createMarkup = (description) => {
            return { __html: description };
        };
        this.onClose = () => {
            if (typeof window !== "undefined") {
                window.localStorage.setItem("cw-modal-dialog", getHash(this.props));
            }
            this.setState({ showModal: false });
        };
        this.isModalContentChanged = () => {
            if (typeof window !== "undefined") {
                const oldHash = window.localStorage.getItem("cw-modal-dialog");
                const newHash = getHash(this.props);
                if (oldHash !== newHash) {
                    return true;
                }
            }
            return false;
        };
        this.renderBasedOnMode = (markedContent) => {
            let mode = this.props.mode;
            switch (mode) {
                case MODE_LANDSCAPE_IMAGE_TOP:
                    return this.renderLandscapeImageTop(markedContent);
                case MODE_PORTRAIT_IMAGE_LEFT:
                    return this.renderPortraitImageLeft(markedContent);
                case MODE_BIG_IMAGE:
                    return this.renderImageOnly();
                default:
                    return this.renderOnlyText(markedContent);
            }
        };
        this.renderImageOnly = () => {
            const { poster } = this.props;
            return (React.createElement("div", { className: "image-only" },
                React.createElement("div", { className: "big-image" },
                    React.createElement("a", { href: poster.link, target: poster.target ? "_" + poster.target : "_blank" },
                        "  ",
                        React.createElement("img", { src: poster.url }),
                        " "),
                    React.createElement("div", { className: "circle", onClick: this.onClose },
                        React.createElement("div", { className: "close-item-1" },
                            React.createElement("div", { className: "close-item-2" }))))));
        };
        this.renderPortraitImageLeft = (markedContent) => {
            const { title, poster, primaryButton } = this.props;
            return (React.createElement("div", { className: "portrait-image-left" },
                React.createElement("div", { className: "left-image" },
                    React.createElement("a", { href: poster.link, target: poster.target ? poster.target : "_blank" },
                        "  ",
                        React.createElement("img", { src: poster.url }),
                        " ")),
                React.createElement("div", { className: "text" },
                    React.createElement("div", { className: "title" }, title),
                    React.createElement("div", { className: "body" },
                        React.createElement("div", { className: "content-container", dangerouslySetInnerHTML: this.createMarkup(markedContent) })),
                    React.createElement("div", { className: "action" },
                        React.createElement("div", { className: "action-button" },
                            React.createElement("a", { type: "button", className: "primary-button", href: primaryButton.link, target: primaryButton.target }, primaryButton.text)))),
                React.createElement("div", { className: "circle", onClick: this.onClose },
                    React.createElement("div", { className: "close-item-1" },
                        React.createElement("div", { className: "close-item-2" })))));
        };
        this.renderLandscapeImageTop = (markedContent) => {
            const { title, poster, primaryButton } = this.props;
            return (React.createElement("div", { className: "landscape-image-top" },
                React.createElement("div", { className: "top-image" },
                    React.createElement("div", null,
                        React.createElement("a", { href: poster.link, target: poster.target ? poster.target : "_blank" },
                            "  ",
                            React.createElement("img", { src: poster.url }),
                            " ")),
                    React.createElement("div", { className: "circle", onClick: this.onClose },
                        React.createElement("div", { className: "close-item-1" },
                            React.createElement("div", { className: "close-item-2" })))),
                React.createElement("div", { className: "title" }, title),
                React.createElement("div", { className: "body" },
                    React.createElement("div", { className: "content-container", dangerouslySetInnerHTML: this.createMarkup(markedContent) })),
                React.createElement("div", { className: "action" },
                    React.createElement("div", { className: "action-button" },
                        React.createElement("a", { type: "button", className: "primary-button", href: primaryButton.link, target: primaryButton.target }, primaryButton.text)))));
        };
        this.renderOnlyText = (markedContent) => {
            const { title, primaryButton } = this.props;
            return (React.createElement("div", { className: "only-text" },
                React.createElement("div", { className: "circle", onClick: this.onClose },
                    React.createElement("div", { className: "close-item-1" },
                        React.createElement("div", { className: "close-item-2" }))),
                React.createElement("div", { className: "title" }, title),
                React.createElement("div", { className: "body" },
                    React.createElement("div", { className: "content-container", dangerouslySetInnerHTML: this.createMarkup(markedContent) })),
                React.createElement("div", { className: "action" },
                    React.createElement("div", { className: "action-button" },
                        React.createElement("a", { type: "button", className: "primary-button", href: primaryButton.link, target: primaryButton.target }, primaryButton.text)))));
        };
        moment.locale("nb");
        marked_ts_1.Marked.setOptions({
            gfm: true,
            tables: true,
            breaks: false,
            pedantic: false,
            sanitize: false,
            smartLists: true,
            smartypants: false,
        });
    }
    render() {
        const { body, display } = this.props;
        const isModalContentChanged = this.isModalContentChanged();
        if (!isModalContentChanged || !display) {
            return null;
        }
        const theContent = body ? body : "";
        const markedContent = marked_ts_1.Marked.parse(theContent);
        return (React.createElement("div", { className: "ModalDialog" },
            React.createElement("div", { className: "popup" }, this.renderBasedOnMode(markedContent))));
    }
}
exports.ModalDialog = ModalDialog;
exports.default = ModalDialog;



// WEBPACK FOOTER //
// ./~/@dialogexe/cw-component-modal-dialog/ModalDialog.tsx